/* tslint:disable */
/* eslint-disable */
/**
 * NinjaAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { InstanceStateEnum } from './InstanceStateEnum';
import {
    InstanceStateEnumFromJSON,
    InstanceStateEnumFromJSONTyped,
    InstanceStateEnumToJSON,
} from './InstanceStateEnum';

/**
 * 
 * @export
 * @interface InstanceStateSchema
 */
export interface InstanceStateSchema {
    /**
     * 
     * @type {number}
     * @memberof InstanceStateSchema
     */
    id: number;
    /**
     * 
     * @type {Date}
     * @memberof InstanceStateSchema
     */
    created: Date;
    /**
     * 
     * @type {Date}
     * @memberof InstanceStateSchema
     */
    updated: Date;
    /**
     * 
     * @type {InstanceStateEnum}
     * @memberof InstanceStateSchema
     */
    state: InstanceStateEnum;
    /**
     * 
     * @type {string}
     * @memberof InstanceStateSchema
     */
    reason: string;
}

/**
 * Check if a given object implements the InstanceStateSchema interface.
 */
export function instanceOfInstanceStateSchema(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "created" in value;
    isInstance = isInstance && "updated" in value;
    isInstance = isInstance && "state" in value;
    isInstance = isInstance && "reason" in value;

    return isInstance;
}

export function InstanceStateSchemaFromJSON(json: any): InstanceStateSchema {
    return InstanceStateSchemaFromJSONTyped(json, false);
}

export function InstanceStateSchemaFromJSONTyped(json: any, ignoreDiscriminator: boolean): InstanceStateSchema {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'created': (new Date(json['created'])),
        'updated': (new Date(json['updated'])),
        'state': InstanceStateEnumFromJSON(json['state']),
        'reason': json['reason'],
    };
}

export function InstanceStateSchemaToJSON(value?: InstanceStateSchema | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'created': (value.created.toISOString()),
        'updated': (value.updated.toISOString()),
        'state': InstanceStateEnumToJSON(value.state),
        'reason': value.reason,
    };
}

